import { render } from "./DateField.vue?vue&type=template&id=f5a10028&scoped=true"
import script from "./DateField.vue?vue&type=script&lang=js"
export * from "./DateField.vue?vue&type=script&lang=js"

import "./DateField.vue?vue&type=style&index=0&id=f5a10028&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f5a10028"
/* hot reload */
if (module.hot) {
  script.__hmrId = "f5a10028"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5a10028', script)) {
    api.reload('f5a10028', script)
  }
  
  module.hot.accept("./DateField.vue?vue&type=template&id=f5a10028&scoped=true", () => {
    api.rerender('f5a10028', render)
  })

}

script.__file = "src/components/DateField.vue"

export default script